import { Button } from '@mui/material';

interface ActionButtonsProps {
  onCancel: () => void;
  onApply: () => void;
  disabled?: boolean;
}

const ActionButtons = ({ onCancel, onApply, disabled = false }: ActionButtonsProps) => {
  return (
    <div className="add-series-action-buttons">
      <Button className="cancel-button" onClick={onCancel}>
        Cancel
      </Button>
      <Button className="apply-button" onClick={onApply} disabled={disabled}>
        Apply
      </Button>
    </div>
  );
};

export default ActionButtons;
